// Conditions générales d'utilisation
const cguDefaultState = {
	list : []
};

export default (state = cguDefaultState, action) => {
    switch (action.type) {
        case 'SET_CGU':
            return {
                ...state,
                list: action.data
            };
        default:
        	return state;
    }
};


// WEBPACK FOOTER //
// ./src/reducers/cgu.js